import { render, staticRenderFns } from "./PerformanceCard.vue?vue&type=template&id=1e9bfb68&scoped=true"
import script from "./PerformanceCard.vue?vue&type=script&lang=js"
export * from "./PerformanceCard.vue?vue&type=script&lang=js"
import style0 from "./PerformanceCard.vue?vue&type=style&index=0&id=1e9bfb68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e9bfb68",
  null
  
)

export default component.exports